module.exports = __webpack_public_path__ + "img/0Q3A6947_8_FoamcoreMatted.165caa83.jpg";